import React from 'react'
import Header from './Header'
import Footer from './Footer'

class CookiesPolicy extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <main className="politica_cookies">
                <Header />
                <section className="subheader container">
                    <div className="filter-seyte">
                        <h1>Política de cookies</h1>
                    </div>
                </section>
                <section className="content container">
                    <p>
                        <span>
                            Como se describe en nuestra Política de privacidad, utilizamos cookies y tecnologías similares (conjuntamente referidas como &ldquo;cookies&rdquo;) para
                            asegurarnos de que tengas la mejor experiencia posible en nuestro Sitio Web.
                        </span>
                    </p>
                    <p>
                        <span>&iquest;Qué son las cookies?</span>
                    </p>
                    <p>
                        <span>
                            Las cookies son peque&ntilde;os ficheros de texto colocados automáticamente en su ordenador o dispositivo móvil cuando usted visita prácticamente
                            cualquier sitio web. Las cookies son herramientas utilizadas por los sitios web que visitas para mejorar la experiencia de usuario y la navegación. Las
                            cookies se utilizan para recordar información del usuario, como por ejemplo las preferencias que pueda establecer al visitar un sitio web, los datos de
                            autentificación como usuario registrado o los datos de su cesta de la compra. También se pueden usar para obtener información sobre los hábitos de
                            navegación del usuario o datos de su ordenador, como la dirección IP, el sistema operativo o el navegador utilizado.
                        </span>
                    </p>
                    <p>
                        <span>Tipos de cookies</span>
                    </p>
                    <p>
                        <span>
                            Las cookies pueden ser clasificadas en función de una serie de categorías. Es necesario tener en cuenta que una misma cookie puede estar incluida en más
                            de una categoría.
                        </span>
                    </p>
                    <p>
                        <em>
                            <span>En función de su procedencia, las cookies pueden ser:</span>
                        </em>
                    </p>
                    <ul>
                        <li>
                            <strong>
                                <span>Cookies propias:</span>
                            </strong>
                            <span>
                                &nbsp;son aquellas que pertenecen al mismo dominio o subdominio que aparece en la barra de direcciones del navegador, y son generadas por el mismo
                                sitio web que estamos visitando.
                            </span>
                        </li>
                        <li>
                            <strong>
                                <span>Cookies de terceros:</span>
                            </strong>
                            <span>
                                &nbsp;son aquellas que pertenecen a dominios diferentes del que se está mostrando en la barra de direcciones del navegador, y se generan en otros
                                sitios web. Esto ocurre en páginas que muestran contenido procedente de otros dominios, como por ejemplo anuncios. El uso de las cookies de terceros
                                está sujeto a sus propias políticas de privacidad, y no a esta política.
                            </span>
                        </li>
                    </ul>
                    <p>
                        <em>
                            <span>En función de su persistencia, las cookies pueden ser:</span>
                        </em>
                    </p>
                    <ul>
                        <li>
                            <strong>
                                <span>Cookies de sesión:</span>
                            </strong>
                            <span>
                                &nbsp;son cookies creadas sin una fecha de vencimiento o un intervalo de validez, y que por tanto, existen solo temporalmente en memoria mientras el
                                usuario está visitando el sitio web. Estas cookies suelen borrarse cuando el usuario cierra el navegador (cierra la sesión de navegación).
                            </span>
                        </li>
                        <li>
                            <strong>
                                <span>Cookies persistentes:</span>
                            </strong>
                            <span>
                                &nbsp;son cookies que permanecen en el ordenador del usuario aunque éste cierre la sesión de navegación, y que vuelven a ser enviadas a la web que
                                las creó cada vez que el usuario vuelve a visitarlo. Estas cookies persisten en el ordenador del usuario hasta la fecha de vencimiento que haya
                                establecido el sitio web creador de la cookie.
                            </span>
                        </li>
                    </ul>
                    <p>
                        <em>
                            <span>En función de su finalidad, las cookies pueden ser:</span>
                        </em>
                    </p>
                    <ul>
                        <li>
                            <strong>
                                <span>Cookies técnicas:</span>
                            </strong>
                            <span>&nbsp;son necesarias para la navegación. Sin ellas la página no funcionaría adecuadamente.</span>
                        </li>
                        <li>
                            <strong>
                                <span>Cookies de personalización:</span>
                            </strong>
                            <span>&nbsp;permiten que la página reconozca el idioma del usuario, el tama&ntilde;o de letra, etc.</span>
                        </li>
                        <li>
                            <strong>
                                <span>Cookies de seguridad:</span>
                            </strong>
                            <span>&nbsp;impiden o dificultan ataques contra el sitio web o sus usuarios.</span>
                        </li>
                        <li>
                            <strong>
                                <span>Cookies de análisis:</span>
                            </strong>
                            <span>&nbsp;permiten medir la actividad de los usuarios y elaborar estadísticas de navegación.</span>
                        </li>
                        <li>
                            <strong>
                                <span>Cookies publicitarias:</span>
                            </strong>
                            <span>&nbsp;gestionan la frecuencia y el contenido de los anuncios.</span>
                        </li>
                        <li>
                            <strong>
                                <span>Cookies de publicidad comportamental:</span>
                            </strong>
                            <span>&nbsp;almacenan información sobre los usuarios para mostrarles publicidad personalizada.</span>
                        </li>
                    </ul>
                    <p>
                        <span>Cookies utilizadas en nuestro Sitio Web</span>
                    </p>
                    <p>
                        <span>Las tablas que publicamos a continuación recogen de forma esquematizada las cookies utilizadas en nuestro Sitio Web.</span>
                    </p>
                    <p>
                        <span>&nbsp;</span>
                    </p>
                    <p>
                        <span>&nbsp;Aceptación de las cookies</span>
                    </p>
                    <p>
                        <span>
                            Si no desea recibir cookies, puede cambiar la configuración de su navegador. Si utiliza nuestro sitio web sin cambiar la configuración de su navegador,
                            asumiremos que usted acepta el uso de cookies en nuestro Sitio Web. No obstante, en cualquier momento, usted podrá ejercer su derecho de desactivación o
                            eliminación de las cookies de este Sitio Web.
                        </span>
                    </p>
                    <p>
                        <span>
                            En la parte inferior de todas las páginas de nuestro Sitio Web se mostrará un aviso con información sobre la utilización de Cookies en nuestro Sitio Web
                            para que usted sea consciente. Ante esta información es posible llevar a cabo las siguientes acciones:
                        </span>
                    </p>
                    <ul>
                        <li>
                            <strong>
                                <span>Aceptar:</span>
                            </strong>
                            <span>
                                &nbsp;En este caso no se volverá a visualizar el aviso con información sobre la utilización de Cookies en nuestro Sitio Web durante un determinado
                                periodo de tiempo, enviándose una cookie adicional para salvaguardar su elección. No obstante, siempre mostrará un enlace a nuestra Política de
                                Cookies en la parte inferior de todas nuestras páginas.
                            </span>
                        </li>
                        <li>
                            <strong>
                                <span>Ver política de cookies:</span>
                            </strong>
                            <span>
                                &nbsp;En este caso será transferido a la presente Política de Cookies. Esta acción no evitará que se muestre el aviso con información sobre la
                                utilización de Cookies en nuestro Sitio Web.
                            </span>
                        </li>
                        <li>
                            <span>
                                Usted además en cualquier momento puede restringir, bloquear o borrar las cookies de este Sitio Web, o de cualquier otra página web, configurando
                                las opciones de su navegador. Esta acción no evitará que se muestre el aviso con información sobre la utilización de Cookies en nuestro Sitio Web.
                            </span>
                        </li>
                    </ul>
                    <p>
                        <span>&iquest;Cómo puedo gestionar el uso de cookies?</span>
                    </p>
                    <p>
                        <span>
                            Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su
                            equipo. Los pasos para hacerlo son diferentes para cada navegador y se pueden encontrar instrucciones en el men&uacute; de ayuda de su navegador. No
                            obstante, a continuación le proporcionamos información relativa a los navegadores más populares:
                        </span>
                    </p>
                    <ul>
                        <li>
                            <span>Para más información sobre Internet Explorer pulse&nbsp;</span>
                            <span>
                                <a href="http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-11">
                                    <span>aquí</span>
                                </a>
                            </span>
                            <span>.</span>
                        </li>
                        <li>
                            <span>Para más información sobre Mozilla Firefox pulse&nbsp;</span>
                            <span>
                                <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias">
                                    <span>aquí</span>
                                </a>
                            </span>
                            <span>.</span>
                        </li>
                        <li>
                            <span>Para más información sobre Google Chrome pulse&nbsp;</span>
                            <span>
                                <a href="https://support.google.com/chrome/answer/95647?hl=es">
                                    <span>aquí</span>
                                </a>
                            </span>
                            <span>.</span>
                        </li>
                        <li>
                            <span>Para más información sobre Safari pulse&nbsp;</span>
                            <span>
                                <a href="https://support.apple.com/es-es/HT201265">
                                    <span>aquí</span>
                                </a>
                            </span>
                            <span>.</span>
                        </li>
                    </ul>
                    <p>
                        <span>Más información</span>
                    </p>
                    <p>
                        <span>Si desea más información sobre las cookies puede visitar los siguientes enlaces:</span>
                    </p>
                    <ul>
                        <li>
                            <span>
                                <a href="http://www.allaboutcookies.org/es/">
                                    <span>All About Cookies</span>
                                </a>
                            </span>
                        </li>
                        <li>
                            <span>
                                <a href="http://www.agpd.es/portalwebAGPD/canaldocumentacion/publicaciones/common/Guias/Guia_Cookies.pdf">
                                    <span>Guía sobre el uso de las cookies de la Agencia Espa&ntilde;ola de Protección de Datos</span>
                                </a>
                            </span>
                        </li>
                    </ul>
                    <p>
                        <span>Si tiene alguna pregunta sobre esta Política de Cookies, por favor contáctenos.</span>
                    </p>
                    <p>&nbsp;</p>
                </section>
                <Footer />
            </main>
        )
    }
}

export default CookiesPolicy



// WEBPACK FOOTER //
// ./src/components/CookiesPolicy.js